<img [class]="classes"
    [src]="media?.asset_url ? media?.base_url+transformations+media?.asset_url : media?.file_url"
    [alt]="altText || media?.description"
>